import api from '../api'

export default {

  accounts: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/accounts?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  invoices: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/accounts/invoices?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  payments: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/accounts/payments?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  credits: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/accounts/credits?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  debits: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/accounts/debits?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  get: async (id) => {
    return api.get(`api/accounts/${id}/show`)
  },

  accountInvoices: async (id,page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/accounts/${id}/invoices?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  accountGrvs: async (id,page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/accounts/${id}/grvs?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  accountPayments: async (id,page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/accounts/${id}/payments?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  accountCredits: async (id,page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/accounts/${id}/credits?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  accountDebits: async (id,page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/accounts/${id}/debits?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  accountStatement: async (id,from,to) => {
    return api.get(`api/accounts/${id}/statement?from=${from}&to=${to}`)
  },

  paymentTypes: async()=>{
    return api.get(`api/accounts/payment-types`)
  },

  paymentCreate: async(payment)=>{
    return api.post(`api/accounts/payment`,payment)
  },

  creditCreate: async(credit)=>{
    return api.post(`api/accounts/credit`,credit)
  },

  debitCreate: async(debit)=>{
    return api.post(`api/accounts/debit`,debit)
  },

  invoicePaid: async(id)=>{
    return api.get(`api/accounts/invoices/${id}/paid`)
  },

  invoiceUnpaid: async(id)=>{
    return api.get(`api/accounts/invoices/${id}/unpaid`)
  },

  invoiceCreateRelatedData: async () => {
    return api.get('api/accounts/invoices/create')
  },

  invoiceCreateGetParts: async (search) => {
    return api.get('api/accounts/invoices/create/parts?search='+search)
  },

  invoiceCreate: async(invoice)=>{
    return api.post(`api/accounts/invoices`,invoice)
  },


}
